module.exports = __webpack_public_path__ + "img/1532846168.59a04bc3.jpg";